import {
  GET_QUOTES,
} from 'constants/quotes';

export default (state = [], action) => {
    switch (action.type) {
    case `${GET_QUOTES}_SUCCESS`:
      return action.payload;
    default:
      return state;
  }
};
